import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageTemplate from '../../../components/PageTemplate/PageTemplate';
import assistantText from '../../../assets/text/text.json';
import PrimaryButtonCard from '../../../components/PrimaryButtonCard/PrimaryButtonCard';
import { setSearchTerm, clearSearchTerm, getSuggestions } from '../../../redux/actions/result.action';

//icon
import thumbDown from '../../../assets/thump_down.png';
import thumbUp from '../../../assets/thump_up.png';
import { pushAndStop, setTextToSpeak } from '../../../redux/actions/text.action';

class InputSpeechValidation extends Component<{navigateTo: any, speak: any, searchTerm: any, setText: any, setSearchTerm: any, clear: any }, { }> {

  componentDidMount() {
    this.props.speak(this.props.searchTerm);
  }

  render() {
    return (
        <div className="inputphotovalidation">
            <PageTemplate assistantLine1={assistantText.sprachMethodeBestätigung.Assistant.line1} assistantLine2="" body={this.renderBody()} customBack={() => {
                console.log("cool");
            }} />
        </div>
    );
  }

  renderBody() {
    return (
        <div className="container">
            <h1>{ this.props.searchTerm }</h1>
            <div className="btn-container">
                <PrimaryButtonCard text={assistantText.sprachMethodeBestätigung.noButton} icon={thumbDown} action={() => {
                    this.props.clear();
                    this.props.navigateTo('/inputspeech');
                }} />
                <div style={{ width: 100 }}></div>
                <PrimaryButtonCard text={assistantText.sprachMethodeBestätigung.yesButton} icon={thumbUp} action={() => {
                  this.props.setText(this.props.searchTerm);
                  this.props.navigateTo('/subresult')
                }} />
            </div>
        </div>
    )
  }
}


const mapStateToProps = (state: any) => {
  return {
      searchTerm: state.result.searchTerm
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    navigateTo(path: string) {
      dispatch(pushAndStop(path));
    },
    speak(text: string) {
      dispatch(setTextToSpeak(text));
    },
    setText(term: string) {
      dispatch(clearSearchTerm());
      dispatch(setSearchTerm(term));
      dispatch(getSuggestions(term));
    },
    clear() {
      dispatch(clearSearchTerm());
    }
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InputSpeechValidation);